<template>
    <div class="o-highlights__container" v-bind:class="{'o-highlights__container--unloading-mobile': unloading}">
        <div v-if="media_present" class="o-media o-media--slideshow" v-bind:class="{'o-media--active': media_active, 'o-media--unloading': unloading, 'o-media--big-image': slideshow_type == 'big-image' }">
            <img class="o-media__object" :src="first_image">
        </div>
        <div class="o-slideshow" v-bind:class="{'o-slideshow--unloading': unloading, 'o-slideshow--big-image': slideshow_type == 'big-image'}">
            <transition name="fade" mode="out-in">
                <div v-if="loaded" :key="active_slide_index" class="o-slide">
                    <div class="o-slide__media">
                        <img :src="active_slide.image">
                    </div>
                    <div v-if="loaded && slides.length > 1" class="o-slideshow__footer o-slideshow__footer--sm">
                        <menu class="o-slideshow__controls">
                            <div class="o-slideshow__dots">
                                <button v-for="(slide, index) in slides" class="o-slideshow__dot" v-bind:class="{'o-slideshow__dot--active': active_slide_index === index }" :key="index" v-on:click="_activateSlideByIndex( index )">{{ `Actviate slide ${ index + 1 }` }}</button>
                            </div>
                            <button class="o-slideshow__btn" type="button" v-on:click="autoplay_active = !autoplay_active">{{ autoplay_active ? 'pause' : 'play' }}</button>
                        </menu>
                    </div>
                    <div class="o-slide__content" data-aos="fade-up">
                        <div class="o-container">
                            <div v-if="active_slide.heading" class="o-row">
                                <div :class="`${_headingAlignment( active_slide )}`">
                                    <h1 class="o-slideshow__headline" v-html="active_slide.heading"></h1>
                                </div>
                            </div>
                            <div v-if="active_slide.has_cta || active_slide.caption" class="o-row">
                                <div :class="`${slideshow_type == 'big-image' ? 'o-col-lg-3 o-col-xxl-4 o-offset-lg-8' : 'o-col-lg-5 o-col-xxl-6 o-offset-lg-6'}`">
                                    <p class="o-highlights__caption" v-html="active_slide.caption"></p>
                                    <div class="c-button__group" v-if="active_slide.ctas.length > 0">
                                        <cta-button v-for="(cta, index) in active_slide.ctas" :href="cta.url" :label="cta.label" :icon="cta.icon" :key="index.toString()"></cta-button>
                                    </div>
                                </div>
                            </div>
                            <home-button :location="'mobile'"></home-button>
                        </div>
                    </div>
                </div>
            </transition>
            <div v-if="loaded && slides.length > 1" class="o-slideshow__footer o-slideshow__footer--lg">
                <menu class="o-slideshow__controls">
                    <div class="o-slideshow__dots">
                        <button v-for="(slide, index) in slides" class="o-slideshow__dot" v-bind:class="{'o-slideshow__dot--active': active_slide_index === index }" :key="index" v-on:click="_activateSlideByIndex( index )">{{ `Actviate slide ${ index + 1 }` }}</button>
                    </div>
                    <button class="o-slideshow__btn" type="button" v-on:click="autoplay_active = !autoplay_active">{{ autoplay_active ? 'pause' : 'play' }}</button>
                </menu>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: function() {
        return {
            active_slide_index: 0,
            slide_interval: null,
            autoplay_active: true,
            media_active: false,
            media_present: true,
            loaded: false,
        }
    },
    mounted() {

        // @mouseenter="_toggleAutoplay(false)" @mouseleave="_toggleAutoplay(true)"

        setTimeout(() => {
            this.media_active = true;
            this._loadSlideshow();
        }, 100);

        this._startAutoPlay();

        this._slideUpdateEvent();

    },
    beforeDestroy() {
        this.slide_interval = null;
    },
    methods: {
        _startAutoPlay: function() {

            if( this.slide_interval ) clearInterval( this.slide_interval );
        
            if( this.slides.length > 1 ) {
                this.slide_interval = setInterval(() => {
                    if( this.autoplay_active ) this._nextSlide();
                }, 5000 );
            }

        },
        _loadSlideshow: function() {
            setTimeout(() => {
                this.loaded = true;
            }, 700);
            setTimeout(() => {
                this.media_present = false;
            }, 1000);

        },
        _toggleAutoplay: function( autoplay_active ) {
            this.autoplay_active = autoplay_active;
        },
        _nextSlide: function() {

            this.active_slide_index = this.active_slide_index + 1 >= this.slides.length ? 0 : this.active_slide_index + 1;

        },
        _activateSlideByIndex: function( index ) {

            if( isNaN( index ) || index < 0 || ( index + 1 ) > this.slides.length ) {
                // eslint-disable-next-line
                console.warn('attempted to activate a slide with a non index', index );
                return;
            }

            this.active_slide_index = index;

            this._startAutoPlay();
        },
        _slideUpdateEvent: function() {

            if( window.slide_update_timeout ) clearTimeout( window.slide_update_timeout );

            window.slide_update_timeout = setTimeout(() => {

                this.dataLayerPush({
                    "event": "highlight_slide_view",
                    "highlight_name": this.$route.meta.title,
                    "slide_name": this.active_slide.heading
                });

            }, 500 );

        },
        _headingAlignment: function( $slide ) {

            if( this.slideshow_type == 'big-image' ) {
                return 'o-col-lg-3 o-col-xxxl-4 o-offset-lg-8';
            }

            return $slide.heading_alignment == 'caption' ? 'o-col-lg-5 o-col-xxl-6 o-offset-lg-6' : 'o-col-lg-7 o-col-xxl-8 o-offset-lg-4';
        },
    },
    computed: {
        slides: function() {

            let slides_data = this.$route.meta.slideshow_slides || [],
                slide,
                slides = [];

            for( let i = 0; i < slides_data.length; i++ ) {

                slide = {
                    ...slides_data[i],
                    has_cta: slides_data[i].cta_label && slides_data[i].cta_url,
                };

                slides.push( slide );

            }

            return slides;
        },
        active_slide: function() {
            return this.slides[this.active_slide_index];
        },
        slideshow_type: function() {
            return this.$route.meta.slideshow_type;
        },
        first_image: function() {
            return this.$route.meta.slideshow_slides[0].image;
        },
    },
    watch: {
        autoplay_active: function() {
            if( this.autoplay_active ) {
                this._nextSlide();
                this._startAutoPlay();
            }
        },
        active_slide: function() {
            this._slideUpdateEvent();
        }
    }
}
</script>
